import {
  RoomPropertyEnum,
  GolfPropertyEnum,
  RetailPropertyEnum,
  SpaPropertyEnum,
  SnCPropertyEnum,
  ReservePropertyEnum,
} from "./NavbarList";

export const versaSampleData = {
  [RoomPropertyEnum.propertyInformation]: {
    propertyName: "Agilysys Inc",
    addressLine1: "3655 Brookside Pkwy",
    addressLine2: "Suite 300",
    city: "Alpharetta",
    state: "Georgia",
    country: "United States",
    zipCode: "30004",
    phoneNumber: "5715644057",
    email: "sales@agilysys.com",
    checkinTime: "2025-04-09T19:00:00.000Z",
    checkoutTime: "2025-04-09T16:00:00.000Z",
  },
  [RoomPropertyEnum.taxExemptCategory]: [
    {
      id: 1,
      code: "ALL",
      name: "All taxes",
      isActive: true,
    },
  ],
  [RoomPropertyEnum.buildingCodes]: [
    {
      id: 1,
      code: "sample_test_agilysys_HOTEL",
      name: "Hotel",
      taxExemptCategories: "ALL - All taxes",
      isActive: true,
    },
    {
      id: 2,
      code: "sample_test_agilysys_HOTELS",
      name: "Hotel",
      isActive: true,
      taxExemptCategories: "ALL - All taxes",
    },
  ],
  [RoomPropertyEnum.roomFeatures]: [
    {
      id: 1,
      code: "sample_test_agilysys_FRIDG",
      name: "Fridge",
      isActive: true,
      isCondoOnly: true,
    },
    {
      id: 2,
      code: "sample_test_agilysys_OVEN",
      name: "Oven",
      isActive: true,
      isCondoOnly: false,
    },
  ],
  [RoomPropertyEnum.roomLocation]: [
    {
      id: 1,
      code: "sample_test_agilysys_HIGH",
      name: "High Floor",
      isActive: true,
      isCondoOnly: true,
    },
    {
      id: 2,
      code: "sample_test_agilysys_NELEV",
      name: "Near Elevator",
      isActive: true,
      isCondoOnly: false,
    },
  ],
  [RoomPropertyEnum.HousekeepingSections]: [
    {
      id: 1,
      code: "sample_test_agilysys_S1A",
      name: "South 1st Floor A",
      buildingCode: "HOTEL - Hotel",
      isActive: true,
    },
    {
      id: 2,
      code: "sample_test_agilysys_N3C",
      name: "North 3rd Floor C",
      buildingCode: "HOTELS - Hotel",
      isActive: true,
    },
  ],
  [RoomPropertyEnum.roomTypeMaintainence]: [
    {
      id: 1,
      code: "sample_test_agilysys_DQ",
      name: "Deluxe Queen",
      buildingCode: "HOTEL - Hotel",
      noOfRooms: "15",
      maximumGuests: "4",
      maximumNights: "14",
      isBedded: true,
      isUnblockPasscode: true,
      isBlockRequired: true,
      isAllowOversell: true,
      isBlockingReminder: true,
      isSuite: true,
      amount: "25",
      resortFeeType: "Flat",
      feeFrequency: "daily",
      adult: true,
      youth: true,
      teen: true,
      child: true,
      todlers: true,
      isROH: true,
      villaHomeTemplateCode: "VillaTemplate1",
      postTypeName: "Resort Fee",
      countRoomAs: 1,
      isPetAllowed: true,
      noOfPets: "1",
      isNightly: true,
      isHourly: true,
      gapTime: "10",
      minimumOccupancy: "1",
      maximumOccupancy: "6",
      type: 1,
      isActive: true,
    },
    {
      id: 2,
      code: "sample_test_agilysys_DK",
      name: "Deluxe King",
      buildingCode: "HOTEL - Hotel",
      noOfRooms: 0,
      maximumGuests: 0,
      maximumNights: 0,
      isBedded: true,
      isUnblockPasscode: false,
      isBlockRequired: false,
      isAllowOversell: false,
      isBlockingReminder: false,
      isSuite: false,
      amount: 0,
      resortFeeType: "Flat",
      feeFrequency: "daily",
      adult: false,
      youth: false,
      teen: false,
      child: false,
      todlers: false,
      isROH: false,
      villaHomeTemplateCode: "VillaTemplate1",
      postTypeName: "Resort Fee",
      countRoomAs: 0,
      isPetAllowed: false,
      noOfPets: 0,
      isNightly: false,
      isHourly: false,
      gapTime: null,
      minimumOccupancy: null,
      maximumOccupancy: null,
      type: "None",
      isActive: true,
    },
    {
      id: 3,
      code: "sample_test_agilysys_DP",
      name: "Deluxe Pool",
      buildingCode: "HOTEL - Hotel",
      noOfRooms: 0,
      maximumGuests: 0,
      maximumNights: 0,
      isBedded: true,
      isUnblockPasscode: false,
      isBlockRequired: false,
      isAllowOversell: false,
      isBlockingReminder: false,
      isSuite: false,
      amount: 0,
      resortFeeType: "Flat",
      feeFrequency: "daily",
      adult: false,
      youth: false,
      teen: false,
      child: false,
      todlers: false,
      isROH: false,
      villaHomeTemplateCode: "VillaTemplate1",
      postTypeName: "Resort Fee",
      countRoomAs: 1,
      isPetAllowed: false,
      noOfPets: 0,
      isNightly: false,
      isHourly: false,
      gapTime: null,
      minimumOccupancy: null,
      maximumOccupancy: null,
      type: "None",
      isActive: true,
    },
  ],
  [RoomPropertyEnum.roomDefinitions]: [
    {
      id: 1,
      roomNumber: "sample_test_agilysys_110",
      roomTypeCode: "DQ - Deluxe Queen",
      buildingCode: "HOTEL - Hotel",
      description: "Queen size bed",
      isSuite: true,
      beds: "2",
      connectingRoomCodes: "2",
      stayOverPoints: "0.5",
      checkPoints: "1",
      housekeepingSection: "S1A - South 1st Floor A",
      roomFeatures: ["OVEN - Oven"],
      roomLocations: ["HIGH - High Floor"],
      condo: true,
      condoDescription: "condo1",
      condoFirstName: "Condonew",
      condoLastName: "Band",
      condoNightAvailable: true,
      condoRentedToGuest: true,
      condoRendedToOwner: true,
      condoRoomRevenue: "10",
      condoUnitCondition: "good",
      condoAddress: "1232 Deer trail",
      condoContactDetails: "3454565678",
      isSmoking: true,
      allowPets: true,
      petCount: "1",
      roomCount: "1",
      isActive: true,
      isCotNotAllowed: false,
      isCribNotAllowed: false,
      ownershipType: "None",
      isBedded: true,
      isNoAutoPostRoomAndTax: false,
      roomsForOccupancyTax: false,
      suiteRoomCodes: [],
      blockingOrder: 0,
      floor: 0,
      energySection: 0,
      keyNumber: 0,
      licenseFromDate: "2025-04-09",
      licenseToDate: "2030-04-09",
      physicalAddress: "",
      lastDecorated: "2025-04-09",
      matressTurned: "2025-04-09",
      roomStatus: "V",
    },
    {
      id: 2,
      roomNumber: "sample_test_agilysys_112",
      roomTypeCode: "DQ - Deluxe Queen",
      buildingCode: "HOTEL - Hotel",
      description: "Room Description",
      isSuite: false,
      beds: 0,
      connectingRoomCodes: [],
      stayOverPoints: 0,
      checkPoints: 0,
      housekeepingSection: "S1A - South 1st Floor A",
      roomFeatures: ["OVEN - Oven"],
      roomLocations: ["HIGH - High Floor"],
      condo: false,
      condoDescription: "condo2",
      condoFirstName: "Condo New",
      condoLastName: "Test",
      condoNightAvailable: false,
      condoRentedToGuest: false,
      condoRendedToOwner: false,
      condoRoomRevenue: 0,
      condoUnitCondition: "best",
      condoAddress: "3655 Brookside Pkwy",
      condoContactDetails: "98652499037",
      isSmoking: false,
      allowPets: false,
      petCount: false,
      roomCount: false,
      isActive: true,
      isCotNotAllowed: false,
      isCribNotAllowed: false,
      ownershipType: "None",
      isBedded: true,
      isNoAutoPostRoomAndTax: false,
      roomsForOccupancyTax: false,
      suiteRoomCodes: [],
      blockingOrder: 0,
      floor: 0,
      energySection: 0,
      keyNumber: 0,
      licenseFromDate: "2025-04-09",
      licenseToDate: "2030-04-09",
      physicalAddress: "",
      lastDecorated: "2025-04-09",
      matressTurned: "2025-04-09",
      roomStatus: "V",
    },
  ],
  [RoomPropertyEnum.department]: [
    {
      id: 1,
      name: "sample_test_agilysys_PAYMENT",
    },
    {
      id: 2,
      name: "sample_test_agilysys_ROOM",
    },
  ],
  [RoomPropertyEnum.category]: [
    {
      id: 1,
      name: "sample_test_agilysys_ROOM",
      departmentName: "ROOM",
    },
    {
      id: 2,
      name: "sample_test_agilysys_PAYMENT",
      departmentName: "PAYMENT",
    },
  ],
  [RoomPropertyEnum.taxes]: [
    {
      id: 1,
      taxType: "sample_test_agilysys_STAX",
      postTypeName: "1 - PAYMENT",
      exemptDays: "1",
      effectiveDate: "2025-04-09T20:01:13.763Z",
      pSTTax: "2",
      extractCode: "2",
      isTaxable: true,
      isPostWithRoom: true,
      isSpecializedUse: true,
      isGSTTax: true,
      isOccupancyTax: true,
      isOCCTaxNoOfRooms: true,
      isPostTaxToFirstFolio: true,
      isShowOnSplits: true,
      taxExemptCategory: "ALL - All taxes",
      taxMaintenances: [],
      isActive: true,
    },
    {
      id: 2,
      taxType: "sample_test_agilysys_OCCTAX",
      postTypeName: "2 - ROOM",
      exemptDays: "",
      effectiveDate: "Wed Apr 09 2025",
      pSTTax: "",
      extractCode: "",
      isTaxable: false,
      isPostWithRoom: false,
      isSpecializedUse: false,
      isGSTTax: false,
      isOccupancyTax: false,
      isOCCTaxNoOfRooms: false,
      isPostTaxToFirstFolio: false,
      isShowOnSplits: false,
      taxMaintenances: [],
      isActive: true,
    },
    {
      id: 3,
      taxType: "sample_test_agilysys_OCCT2",
      postTypeName: "1 - PAYMENT",
      exemptDays: 0,
      effectiveDate: "2025-04-09T20:28:43.519Z",
      pSTTax: "0",
      extractCode: null,
      isTaxable: false,
      isPostWithRoom: false,
      isSpecializedUse: false,
      isGSTTax: false,
      isOccupancyTax: false,
      isOCCTaxNoOfRooms: false,
      isPostTaxToFirstFolio: false,
      isShowOnSplits: false,
      taxExemptCategory: null,
      taxMaintenances: [],
      isActive: true,
    },
    {
      id: 4,
      taxType: "sample_test_agilysys_OCC3TA",
      postTypeName: "1 - PAYMENT",
      exemptDays: 0,
      effectiveDate: "2025-04-09T20:29:05.160Z",
      pSTTax: null,
      extractCode: null,
      isTaxable: false,
      isPostWithRoom: false,
      isSpecializedUse: false,
      isGSTTax: false,
      isOccupancyTax: false,
      isOCCTaxNoOfRooms: false,
      isPostTaxToFirstFolio: false,
      isShowOnSplits: false,
      taxExemptCategory: null,
      taxMaintenances: [],
      isActive: true,
    },
  ],
  [RoomPropertyEnum.postTypes]: [
    {
      id: 1,
      postTypeNumber: 99,
      departmentName: "sample_test_agilysys_PAYMENT",
      categoryName: 1,
      postTypeName: "Payment",
      isActive: true,
      isCredit: true,
      isDeposit: true,
      characteristics: "Debit",
      postTypeCategory: "Revenue",
      defaultAmount: "0",
      floorLimit: "11",
      ceilingLimit: "11",
      groupingFunctionality: [],
      isRequiredReference: true,
      isRestrictReservationPost: true,
      isRequireComment: true,
      isPasscode: true,
      defaultFolio: 1,
      defaultMasterFolio: "1",
      glNumber: 1,
      glOffsetNumber: 1,
      sageExtractNumber: "1",
      extractRevenueBracket: "1",
      isCommisionable: true,
      commissionFlat: "1",
      isChargedToCondoOwner: true,
      isCommissionPecentage: true,
      commissionPercentage: "1",
      isGiftCard: true,
      giftCardType: false,
      taxes: [],
    },
    {
      id: 2,
      postTypeNumber: 299,
      departmentName: "sample_test_agilysys_ROOM",
      categoryName: 0,
      postTypeName: "",
      isActive: true,
      isCredit: false,
      isDeposit: false,
      characteristics: "Debit",
      postTypeCategory: "Revenue",
      defaultAmount: 0,
      floorLimit: 0,
      ceilingLimit: 0,
      groupingFunctionality: [],
      isRequiredReference: false,
      isRestrictReservationPost: false,
      isRequireComment: false,
      isPasscode: false,
      defaultFolio: 1,
      defaultMasterFolio: 1,
      glNumber: 1,
      glOffsetNumber: 1,
      sageExtractNumber: 1,
      extractRevenueBracket: 1,
      isCommisionable: false,
      commissionFlat: false,
      isChargedToCondoOwner: false,
      isCommissionPecentage: false,
      commissionPercentage: 0,
      isGiftCard: false,
      giftCardType: false,
      taxes: "",
    },
  ],
  [RoomPropertyEnum.guestType]: [
    {
      id: 1,
      code: "TRAN",
      name: "Transient",
      isRouteLocalCalls: "route_local_calls",
      isTurndown: true,
      isSkipResortFee: true,
      creditCardPreAuth: "2",
      taxExemptCategories: "ALL - All taxes",
      isActive: true,
    },
    {
      id: 2,
      code: "GROUP",
      name: "Group",
      isRouteLocalCalls: "route_local_calls",
      isTurndown: false,
      isSkipResortFee: false,
      creditCardPreAuth: "0",
      taxExemptCategories: "ALL - All taxes",
      isActive: true,
    },
  ],
  [RoomPropertyEnum.origin]: [
    {
      id: 1,
      code: "sample_test_agilysys_INTER",
      name: "Internet",
      isActive: true,
      isRouteLocalCalls: true,
    },
    {
      id: 2,
      code: "sample_test_agilysys_GROUP",
      name: "Group",
      isActive: true,
      isRouteLocalCalls: false,
    },
  ],
  [RoomPropertyEnum.PaymentMethods]: [
    {
      id: 1,
      code: "CC",
      name: "Credit Card",
      paymentType: "Card",
      postTypeNumber: "1 - PAYMENT",
      isUseSpecialGuarentee: true,
      creditLimit: "2",
      isActivateInterface: true,
      isRestrictPOSChanges: true,
      isMovieRestrictions: true,
      isInterfacePostToCheckoutFolio: true,
      centralResvEquivalent: "12",
      phoneRestrictions: 1,
      isActive: true,
    },
    {
      id: 2,
      code: "CASH",
      name: "Cash",
      paymentType: "Cash",
      postTypeNumber: 0,
      isUseSpecialGuarentee: false,
      creditLimit: 0,
      isActivateInterface: false,
      isRestrictPOSChanges: false,
      isMovieRestrictions: false,
      isInterfacePostToCheckoutFolio: false,
      centralResvEquivalent: "12",
      phoneRestrictions: 0,
      isActive: true,
    },
  ],
  [RoomPropertyEnum.Segment1]: [
    {
      id: 1,
      code: "sample_test_agilysys_CALL",
      name: "Call In",
      isRouteLocalCalls: true,
      guestTypeCode: "TRAN - Transient",
      isActive: true,
    },
    {
      id: 2,
      code: "sample_test_agilysys_CORP",
      name: "Corporate",
      isRouteLocalCalls: false,
      guestTypeCode: "GROUP - Group",
      isActive: true,
    },
  ],
  [RoomPropertyEnum.Segment2]: [
    {
      id: 1,
      code: "sample_test_agilysys_DISC",
      name: "Discounted",
      isRouteLocalCalls: true,
      parentSegment1Code: "CALL - Call In",
      guestTypeCode: "TRAN - Transient",
      isActive: true,
    },
    {
      id: 2,
      code: "sample_test_agilysys_RLIST",
      name: "Rooming List",
      isRouteLocalCalls: false,
      parentSegment1Code: 0,
      guestTypeCode: 0,
      isActive: true,
    },
  ],
};

export const sncSampleData = {
  [SnCPropertyEnum.propertyInformation]: {
    propertyName: "Agilysys Inc",
    addressLine1: "3655 Brookside Pkwy",
    addressLine2: "Suite 300",
    city: "Alpharetta",
    state: "Georgia",
    country: "United States",
    zipCode: "30004",
    phoneNumber: "5715644057",
    email: "sales@agilysys.com",
    checkinTime: "2025-04-09T19:00:00.000Z",
    checkoutTime: "2025-04-09T16:00:00.000Z",
  },
  [SnCPropertyEnum.arrivalTypes]: [
    {
      id: 1,
      "Arrival Type Code": "sample_test_agilysys_SnC",
      "Arrival Type Name": "sample_test_agilysys_SnC",
    },
  ],
  [SnCPropertyEnum.audioVisualItems]: [
    {
      id: 1,
      "Audio Visual Code": "sample_test_agilysys_SnC",
      "Audio Visual Name": "sample_test_agilysys_SnC",
      Active: "Yes",
      "Revenue Types": [],
    },
  ],
  [SnCPropertyEnum.beverageItems]: [
    {
      id: 1,
      "Beverage Code": "sample_test_agilysys_SnC",
      "Beverage Name": "sample_test_agilysys_SnC",
      Active: "Yes",
      "Revenue Types": [],
    },
  ],
  [SnCPropertyEnum.cancelCodes]: [
    {
      id: 1,
      "Cancel Code": "sample_test_agilysys_SnC",
      "Cancel Code Name": "sample_test_agilysys_SnC",
    },
  ],
  [SnCPropertyEnum.cancellationPolicy]: [
    {
      id: 1,
      "Cancellation Policy Code": "sample_test_agilysys_SnC",
      "Cancellation Policy Name": "sample_test_agilysys_SnC",
      "Cancellation Policy": "sample_test_agilysys_SnC",
    },
  ],
  [SnCPropertyEnum.managers]: [
    {
      id: 1,
      MANAGER_GROUP_NUMBER: 1,
      MAPPING_CODE: "sample_test_agilysys_SnC_SM",
      MANAGER_TYPE: "SALESMANAGER",
      ISACTIVE: true,
      MANAGER_FIRSTNAME: "sample_test_agilysys_SnC",
      MANAGER_LASTNAME: "sample_test_agilysys_SnC",
    },
    {
      id: 2,
      MANAGER_GROUP_NUMBER: 2,
      MAPPING_CODE: "sample_test_agilysys_SnC_CSM",
      MANAGER_TYPE: "CONFERENCESERVICEMANAGER",
      ISACTIVE: true,
      MANAGER_FIRSTNAME: "sample_test_agilysys_SnC",
      MANAGER_LASTNAME: "sample_test_agilysys_SnC",
    },
    {
      id: 3,
      MANAGER_GROUP_NUMBER: 3,
      MAPPING_CODE: "sample_test_agilysys_SnC_CM",
      MANAGER_TYPE: "CATERINGMANAGER",
      ISACTIVE: true,
      MANAGER_FIRSTNAME: "sample_test_agilysys_SnC",
      MANAGER_LASTNAME: "sample_test_agilysys_SnC",
    },
  ],
  [SnCPropertyEnum.contactType]: [
    {
      id: 1,
      "Contact Type Code": "sample_test_agilysys_SnC",
      "Contact Type Name": "sample_test_agilysys_SnC",
    },
  ],
  [SnCPropertyEnum.denialCodes]: [
    {
      id: 1,
      "Denial Code": "sample_test_agilysys_SnC",
      "Denial Code Name": "sample_test_agilysys_SnC",
    },
  ],
  [SnCPropertyEnum.distributionList]: [
    {
      id: 1,
      "Distribution List Code": "sample_test_agilysys_SnC",
      "Distribution List Name": "sample_test_agilysys_SnC",
    },
  ],
  [SnCPropertyEnum.foodTypes]: [
    {
      id: 1,
      "Food Type Code": "sample_test_agilysys_SnC",
      "Food Type Name": "sample_test_agilysys_SnC",
    },
  ],
  [SnCPropertyEnum.functionRoom]: [
    {
      id: 1,
      "Function Room Code": "sample_test_agilysys_SnC",
      "Function Room Name": "sample_test_agilysys_SnC",
      Building: null,
      "Revenue Type": null,
      "Room Features": [],
    },
  ],
  [SnCPropertyEnum.functionRoomSetup]: [
    {
      id: 1,
      "Setup Style Code": "sample_test_agilysys_SnC",
      "Setup Style Name": "sample_test_agilysys_SnC",
    },
  ],
  [SnCPropertyEnum.functionRoomsFeatures]: [
    {
      id: 1,
      "Feature Code": "sample_test_agilysys_SnC",
      "Feature Name": "sample_test_agilysys_SnC",
    },
  ],
  [SnCPropertyEnum.functionRoomTypeFee]: [
    {
      id: 1,
      "Fee Type Code": "sample_test_agilysys_SnC",
      "Fee Type Name": "sample_test_agilysys_SnC",
    },
  ],
  [SnCPropertyEnum.functionTypes]: [
    {
      id: 1,
      "Function Type Code": "sample_test_agilysys_SnC",
      "Function Type Code Name": "sample_test_agilysys_SnC",
    },
  ],
  [SnCPropertyEnum.holidaysAndHotDates]: [
    {
      id: 1,
      "Holiday/Hot Date Code": "sample_test_agilysys_SnC",
      "Holiday/Hot Date Name": "sample_test_agilysys_SnC",
      "Start Date": "sample_test_agilysys_SnC",
      "End Date": "sample_test_agilysys_SnC",
      "Number Of Nights": 0,
      "Display Location": "All",
      "Display Line": "Holidays",
      Active: "Yes",
    },
  ],
  [SnCPropertyEnum.incidentals]: [
    {
      id: 1,
      "Incidental Code": "sample_test_agilysys_SnC",
      "Incidental Name": "sample_test_agilysys_SnC",
    },
  ],
  [SnCPropertyEnum.menuItems]: [
    {
      id: 1,
      "Menu Item Code": "sample_test_agilysys_SnC",
      "Menu Item Name": "sample_test_agilysys_SnC",
      "Food Types": ["sample_test_agilysys_SnC"],
      "Units of Measure": ["sample_test_agilysys_SnC"],
      Active: "Yes",
      "Revenue Types": [],
    },
  ],
  [SnCPropertyEnum.miscellaneousItems]: [
    {
      id: 1,
      "Miscellaneous Code": "sample_test_agilysys_SnC",
      "Miscellaneous Name": "sample_test_agilysys_SnC",
      Active: "Yes",
      "Revenue Types": [],
    },
  ],
  [SnCPropertyEnum.potentialCodes]: [
    {
      id: 1,
      "Potential Code": "sample_test_agilysys_SnC",
      "Potential Code Name": "sample_test_agilysys_SnC",
    },
  ],
  [SnCPropertyEnum.reservedByCodes]: [
    {
      id: 1,
      "Reserved By Code": "sample_test_agilysys_SnC",
      "Reserved By Name": "sample_test_agilysys_SnC",
    },
  ],
  [SnCPropertyEnum.categoryGroups]: [
    {
      id: 1,
      "Category Group": "sample_test_agilysys_SnC Category Group",
      Active: true,
    },
  ],
  [SnCPropertyEnum.retailCategories]: [
    {
      id: 1,
      "Category Group": "sample_test_agilysys_SnC Category Group",
      "Category Name": "sample_test_agilysys_SnC Category",
      "Eligible for Discount": "Yes",
      Active: true,
    },
  ],
  [SnCPropertyEnum.retailItems]: [
    {
      id: 1,
      "Item Number": 500,
      "Item Description": "sample_test_agilysys_SnC_Retail_Item",
      Category: "sample_test_agilysys_SnC Category",
      "Sub Category 1": "",
      "Sub Category 2": "",
      "Sub Category 3": "",
      "Sub Category 4": "",
      "Sub Category 5": "",
      "Unit of Measure": "",
      "Sales Price": 16,
      "Bar Code": 500,
      "Secondary Bar Code": "",
      Tax: "",
      "Item Type": 6,
      "Commission Percent": 0,
      "Commissionable Item": 0,
      "Commission Required": 0,
      "Use Inventory": 0,
      "Grouping Key": 0,
      "Open Items": 0,
      Multipacks: 0,
      Gratuity: 0,
      "Service Charge": 0,
      "Outlet Code": "sample_test_agilysys_SnC",
      Quantity: 10,
      "Unit Cost": 0,
      "Item Par": 0,
      "Outlet Switch": 0,
      "Allow Earn": 0,
    },
  ],
  [SnCPropertyEnum.roomAndTax]: [
    {
      id: 1,
      "Room and Tax Code": "sample_test_agilysys_SnC",
      "Room and Tax Name": "sample_test_agilysys_SnC",
    },
  ],
  [SnCPropertyEnum.salesCallsCallTypes]: [
    {
      id: 1,
      "Call Type Code": "sample_test_agilysys_SnC",
      "Call Type Name": "sample_test_agilysys_SnC",
    },
  ],
  [SnCPropertyEnum.salesCallsNextSteps]: [
    {
      id: 1,
      "Next Step Code": "sample_test_agilysys_SnC",
      "Next Step Name": "sample_test_agilysys_SnC",
    },
  ],
  [SnCPropertyEnum.setupItems]: [
    {
      id: 1,
      "Setup Code": "sample_test_agilysys_SnC",
      "Setup Name": "sample_test_agilysys_SnC",
      Active: "Yes",
      "Revenue Types": [],
    },
  ],
  [SnCPropertyEnum.unitsOfMeasure]: [
    {
      id: 1,
      "Unit of Measure Code": "sample_test_agilysys_SnC",
      "Unit of Measure Name": "sample_test_agilysys_SnC",
    },
  ],
};

export const spaSampleData = {
  [SpaPropertyEnum.propertyInformation]: {
    propertyName: "Agilysys Inc",
    addressLine1: "3655 Brookside Pkwy",
    addressLine2: "Suite 300",
    city: "Alpharetta",
    state: "Georgia",
    country: "United States",
    zipCode: "30004",
    phoneNumber: "5715644057",
    email: "sales@agilysys.com",
    checkinTime: "2025-04-09T19:00:00.000Z",
    checkoutTime: "2025-04-09T16:00:00.000Z",
  },
  [SpaPropertyEnum.addOns]: [
    {
      id: 1,
      "Add On Name": "sample_test_agilysys_Paraffin_Hands",
      Commissionable: "Yes",
      "Retail Item Number": 500,
    },
  ],

  [SpaPropertyEnum.outletSetup]: [
    {
      id: 1,
      "Outlet Name": "sample_test_agilysys_Agilysys_Spa",
      "Terminal ID": "1",
      "Profit Center ID": "",
      "Auto Prints Receipts": "Yes",
    },
  ],

  [SpaPropertyEnum.roleSetup]: [
    {
      id: 1,
      "Role Code": "sample_test_agilysys_SPAMGR",
      "Role Name": "Spa_Manager",
      Active: true,
    },
  ],

  [SpaPropertyEnum.breakTypes]: [
    {
      id: 1,
      "Break Code": "sample_test_agilysys_MEAL",
      "Break Name": "Meal Break",
      Paid: "No",
    },
  ],

  [SpaPropertyEnum.categoryGroups]: [
    {
      id: 1,
      "Category Group": "sample_test_agilysys_Spa_Services",
      Active: true,
    },
  ],

  [SpaPropertyEnum.retailCategories]: [
    {
      id: 1,
      "Category Group": "sample_test_agilysys_Spa_Services",
      "Category Name": "sample_test_agilysys_Massage",
      "Eligible for Discount": "Yes",
      Active: true,
    },
  ],

  [SpaPropertyEnum.retailSubCategories]: [
    {
      id: 1,
      "Sub Category Number": 1,
      "Sub Category Name": "sample_test_agilysys_Mens",
      Active: true,
    },
    {
      id: 2,
      "Sub Category Number": 2,
      "Sub Category Name": "Shorts",
      Active: true,
    },
    {
      id: 3,
      "Sub Category Number": 3,
      "Sub Category Name": "Small",
      Active: true,
    },
  ],

  [SpaPropertyEnum.taxes]: [
    {
      id: 1,
      Outlet: "sample_test_agilysys_Agilysys_Spa_Resort",
      "Tax Name": "Sales_Tax",
      "Allow Tax on Service Charge": "No",
      "Allow Tax on Gratuity": "No",
      "Percentage or Flat Amount": "%",
      Value: 6.0,
      "Start Date": "2023-04-01T00:00:00.000Z",
      "End Date": "2050-12-31T00:00:00.000Z",
      "Default to all Retail Items": "Yes",
    },
  ],

  [SpaPropertyEnum.discountTypes]: [
    {
      id: 1,
      "Discount Type": "sample_test_agilysys_Employee",
      Active: true,
    },
  ],

  [SpaPropertyEnum.quickSaleCategories]: [
    {
      id: 1,
      "Quick Sale Category": "sample_test_agilysys_Spa_Day_Passes",
      "Outlet Name": "Agilysys_Spa",
      Active: true,
    },
  ],

  [SpaPropertyEnum.vendorTypes]: [
    {
      id: 1,
      "Vendor Type": "sample_test_agilysys_Golf_Equipment",
    },
  ],

  [SpaPropertyEnum.discountReasons]: [
    {
      id: 1,
      "Discount Reason": "sample_test_agilysys_Frequent_Guest",
      Active: true,
    },
  ],

  [SpaPropertyEnum.cancelReasons]: [
    {
      id: 1,
      "Cancel Reason Description": "sample_test_agilysys_Trip_Plans_Changed",
      Active: "Yes",
    },
  ],

  [SpaPropertyEnum.categoryLinking]: [
    {
      id: 1,
      "Main Category": "sample_test_agilysys_Retail_Skin_Care",
      "Subcategory 1": "Moisturizer",
      "Subcategory 2": "",
      "Subcategory 3": "",
      "Subcategory 4": "",
      "Subcategory 5": "",
    },
  ],

  [SpaPropertyEnum.dayPackages]: [
    {
      id: 1,
      "Package Code": "sample_test_agilysys_PKGCOMBO",
      "Package Description": "Manicure Pedicure Combo",
      "Effective From Date": "2023-06-14",
      "Effective To Date": "2050-12-31",
      Price: 125,
      "Available Sun": "Yes",
      "Available Mon": "Yes",
      "Available Tue": "Yes",
      "Available Wed": "Yes",
      "Available Thu": "Yes",
      "Available Fri": "Yes",
      "Available Sat": "Yes",
      "Minimum Guests": 1,
      "Maximum Guests": 1,
      Points: "",
      Active: "Yes",
      "Linked Item": 300,
    },
  ],

  [SpaPropertyEnum.guestTypes]: [
    {
      id: 1,
      "Guest Type Code": "sample_test_agilysys_LOCAL",
      "Guest Type Name": "Local Guest",
    },
  ],

  [SpaPropertyEnum.priceTypes]: [
    {
      id: 1,
      "Price Type Code": "sample_test_agilysys_STD",
      "Price Type Description": "Standard Price",
      Active: "Yes",
    },
  ],

  [SpaPropertyEnum.vendorSetup]: [
    {
      id: 1,
      "Vendor Code": "sample_test_agilysys_Eminence",
      "Vendor Name": "Eminence",
    },
  ],

  [SpaPropertyEnum.itemNumbersForAddOns]: [
    {
      id: 1,
      "Item Number": 200,
      "Add On Name": "sample_test_agilysys_Paraffin_Hands",
      "Add On Description": "sample_test_agilysys_Add_On_Paraffin_Hands",
      Taxable: "Yes",
      Active: "Yes",
    },
  ],

  [SpaPropertyEnum.itemNumbersForDayPackages]: [
    {
      id: 1,
      "Item Number": 300,
      Type: "sample_test_agilysys_Day_Package",
      "Package Name": "sample_test_agilysys_Manicure_Pedicure_Combo",
      Active: "Yes",
    },
  ],

  [SpaPropertyEnum.itemNumbersForServices]: [
    {
      id: 1,
      "Item Number": 100,
      "Service Group": "sample_test_agilysys_Massage",
      "Service Description": "sample_test_agilysys_Swedish_Massage_50_Min",
      Taxable: "Yes",
      Active: "Yes",
    },
  ],

  [SpaPropertyEnum.logTypes]: [
    {
      id: 1,
      "Log Type Name": "sample_test_agilysys_Complaint",
      Active: "Yes",
    },
  ],

  [SpaPropertyEnum.lostDeniedReasons]: [
    {
      id: 1,
      "Reason Description": "sample_test_agilysys_No_Staff_Available",
      Active: "Yes",
    },
  ],

  [SpaPropertyEnum.noShowReasons]: [
    {
      id: 1,
      "No Show Reason Description": "sample_test_agilysys_Playing_in_Casino",
      Active: "Yes",
    },
  ],

  [SpaPropertyEnum.paymentMethods]: [
    {
      id: 1,
      "Payment Method Name": "sample_test_agilysys_Credit_Card",
      Active: "Yes",
      "Allow Change": "",
      "Outlet Code": "sample_test_agilysys_Agilysys_Spa",
      Default: "",
    },
  ],

  [SpaPropertyEnum.retailItems]: [
    {
      id: 1,
      "Item Number": 500,
      "Item Description": "sample_test_agilysys_FHF_Fluffy_Bunny_Lotion",
      Category: "sample_test_agilysys_Retail_Body_Care",
      "Sub Category 1": "sample_test_agilysys_Lotion",
      "Sub Category 2": "",
      "Sub Category 3": "",
      "Sub Category 4": "",
      "Sub Category 5": "",
      "Unit of Measure": "",
      "Sales Price": 16,
      "Bar Code": 500,
      "Secondary Bar Code": "821569587420",
      Tax: "sample_test_agilysys_Sales_Tax",
      "Item Type": 1,
      "Commission Percent": "",
      "Commissionable Item": 1,
      "Commission Required": 0,
      "Use Inventory": 1,
      "Grouping Key": 0,
      "Open Items": 0,
      Multipacks: 0,
      Gratuity: 0,
      "Service Charge": 0,
      "Outlet Code": "sample_test_agilysys_Agilysys_Spa",
      Quantity: 10,
      "Unit Cost": 8,
      "Item Par": "",
      "Outlet Switch": 0,
      "Allow Earn": 0,
      "Vendor Name": "sample_test_agilysys_Farmhouse_Fresh",
      "Vendor Item #": "sample_test_agilysys_ABC123",
    },
  ],

  [SpaPropertyEnum.serviceEquipment]: [
    {
      id: 1,
      "Equipment Code": "sample_test_agilysys_WAXPOT",
      "Equipment Description": "Wax Pots",
      Quantity: 3,
    },
  ],

  [SpaPropertyEnum.serviceGroups]: [
    {
      id: 1,
      "Service Group Code": "sample_test_agilysys_Massage",
      "Service Group Name": "Massage",
    },
  ],

  [SpaPropertyEnum.serviceLocations]: [
    {
      id: 1,
      "Location Code": "sample_test_agilysys_MASS1",
      "Location Name": "Massage Room 1",
      Capacity: 1,
    },
  ],

  [SpaPropertyEnum.serviceMedicalConditions]: [
    {
      id: 1,
      "Condition Code": "sample_test_agilysys_PREG",
      "Private Condition": "Yes",
      "Condition Description": "Pregnancy",
      "Condition Warning":
        "sample_test_agilysys_This_service_cannot_be_performed_in_the_first_trimester_of_pregnancy",
    },
  ],

  [SpaPropertyEnum.services]: [
    {
      id: 1,
      "Service Group": "sample_test_agilysys_Massage",
      "Service Code": "sample_test_agilysys_MASSWED50",
      "Service Description": "Swedish Massage 50 Min",
      "Service Points": "",
    },
  ],

  [SpaPropertyEnum.therapistSetup]: [
    {
      id: 1,
      "Staff Code": "sample_test_agilysys_JOHNS",
      "First Name": "sample_test_agilysys_John",
      "Last Name": "Smith",
      Gender: "Male",
    },
  ],
};

export const retailSampleData = {
  [RetailPropertyEnum.propertyInformation]: {
    propertyName: "Agilysys Inc",
    addressLine1: "3655 Brookside Pkwy",
    addressLine2: "Suite 300",
    city: "Alpharetta",
    state: "Georgia",
    country: "United States",
    zipCode: "30004",
    phoneNumber: "5715644057",
    email: "sales@agilysys.com",
    checkinTime: "2025-04-09T19:00:00.000Z",
    checkoutTime: "2025-04-09T16:00:00.000Z",
  },
  [RetailPropertyEnum.outletSetup]: [
    {
      id: 1,
      "Outlet Name": "sample_test_agilysys_Main Shop",
      "Terminal ID": "1",
      "Profit Center ID": "",
      "Auto Print Receipts": "Yes",
      Active: "Yes",
    },
  ],
  [RetailPropertyEnum.categoryGroups]: [
    {
      id: 1,
      "Category Group": "sample_test_agilysys_Apparel",
      Active: "Yes",
    },
  ],
  [RetailPropertyEnum.retailCategories]: [
    {
      id: 1,
      "Category Group": "sample_test_agilysys_Apparel",
      "Category Name": "sample_test_agilysys_Mens Apparel",
      Active: "Yes",
      "Eligible for Discount": "Yes",
      "Eligible for Cost Plus": "No",
    },
  ],
  [RetailPropertyEnum.retailSubCategories]: [
    {
      id: 1,
      "Sub Category Number": 1,
      "Sub Category Name": "sample_test_agilysys_Shirts",
      Active: true,
    },
    {
      id: 2,
      "Sub Category Number": 2,
      "Sub Category Name": "Shorts",
      Active: true,
    },
    {
      id: 3,
      "Sub Category Number": 3,
      "Sub Category Name": "Small",
      Active: true,
    },
  ],
  [RetailPropertyEnum.categoryLinking]: [
    {
      id: 1,
      "Main Category": "sample_test_agilysys_Mens Apparel",
      "Subcategory 1": "Shirts",
      "Subcategory 2": "",
      "Subcategory 3": "",
      "Subcategory 4": "",
      "Subcategory 5": "",
    },
  ],
  [RetailPropertyEnum.paymentMethods]: [
    {
      id: 1,
      "Payment Method Name": "sample_test_agilysys_Cash",
      Active: "Yes",
      "Require Receipts": "No",
      "# of Receipts": "0",
      "Require Comment": "No",
    },
  ],
  [RetailPropertyEnum.taxes]: [
    {
      id: 1,
      Outlet: "sample_test_agilysys_Main Shop",
      "Tax Name": "sample_test_agilysys_Sales Tax",
      "Allow Tax on Service Charge": "No",
      "Allow Tax on Gratuity": "No",
      "Percentage or Flat Amount": "Percentage",
      Value: "6",
      "Start Date": new Date().toISOString(),
      "End Date": "",
      "Default to all Retail Items": "Yes",
    },
  ],
  [RetailPropertyEnum.discountTypes]: [
    {
      id: 1,
      "Discount Type": "sample_test_agilysys_Employee",
    },
  ],
  [RetailPropertyEnum.discountReasons]: [
    {
      id: 1,
      "Discount Reason": "sample_test_agilysys_Manager_Approval",
      Active: "Yes",
    },
  ],
  [RetailPropertyEnum.vendorTypes]: [
    {
      id: 1,
      "Vendor Type": "sample_test_agilysys_Bath_Products",
    },
  ],
  [RetailPropertyEnum.vendorSetup]: [
    {
      id: 1,
      "Vendor Type": "sample_test_agilysys_Bath_Products",
      "Vendor Code": "sample_test_agilysys_BATHCO",
      "Vendor Name": "sample_test_agilysys_Bath_Supply_Co",
      "First Name": "sample_test_agilysys_Alex",
      "Last Name": "sample_test_agilysys_Rivera",
      "Address Line 1": "sample_test_agilysys_100_Main_St",
      "Address Line 2": "",
      City: "sample_test_agilysys_Atlanta",
      State: "sample_test_agilysys_GA",
      Country: "United States",
      "Postal Code": "30309",
      "Phone Type": "Office",
      "Country Code": "1",
      "Phone Number": "4045550100",
      "EMail Type": "Office",
      "EMail Address": "orders@example.com",
      Comments: "sample_test_agilysys_Demo_vendor",
      Terms: "sample_test_agilysys_Net_30",
    },
  ],
  [RetailPropertyEnum.retailItems]: [
    {
      id: 1,
      "Item Number": 500,
      "Item Description": "sample_test_agilysys_Vanilla_Candle_8oz",
      Category: "sample_test_agilysys_Candles",
      "Sub Category 1": "",
      "Sub Category 2": "",
      "Sub Category 3": "",
      "Sub Category 4": "",
      "Sub Category 5": "",
      "Unit of Measure": "",
      "Sales Price": 30,
      "Bar Code": 500,
      "Secondary Bar Code": "821569587420",
      Tax: "sample_test_agilysys_Sales Tax",
      "Item Type": 1,
      "Commission Percent": "",
      "Commissionable Item": 0,
      "Commission Required": 0,
      "Use Inventory": 1,
      "Grouping Key": 0,
      "Open Items": 0,
      Multipacks: 0,
      Gratuity: 0,
      "Service Charge": 0,
      "Outlet Code": "sample_test_agilysys_Main_Shop",
      Quantity: 10,
      "Unit Cost": 15,
      "Item Par": "",
      "Outlet Switch": 0,
      "Allow Earn": 0,
      "Vendor Name": "sample_test_agilysys_Yankee_Candle",
      "Vendor Item #": "ABC123",
    },
  ],
  [RetailPropertyEnum.quickSaleCategories]: [
    {
      id: 1,
      "Quick Sale Category": "sample_test_agilysys_Rentals",
      "Outlet Name": "sample_test_agilysys_Main Shop",
      Active: "Yes",
    },
  ],
  [RetailPropertyEnum.roleSetup]: [
    {
      id: 1,
      "Role Code": "sample_test_agilysys_RETAIL_ADMIN",
      "Role Name": "Retail Administrator",
      Active: "Yes",
    },
  ],
  [RetailPropertyEnum.userSetup]: [
    {
      id: 1,
      "First Name": "sample_test_agilysys_Jane",
      "Last Name": "sample_test_agilysys_Doe",
      "User ID": "sample_test_agilysys_jdoe",
      "Quick ID": "12",
      "Email Address": "jane.doe@agilysys.com",
      Language: "English",
      "Password Expiration Date": "",
      "New Password": "",
      "Application Access": "Retail",
      Active: "Yes",
      "Allow Gratuity": "No",
      "Allow Service Charge": "No",
      "Allow Commission": "No",
      "Commission Class": "",
      "Outlet Access": "Main Shop",
      "Role Name": "Retail Administrator",
      "Account Blocked": "No",
      "Auto Log Off": "No",
      "Log Off # of Minutes": "",
    },
  ],
};

export const golfSampleData = {
  [GolfPropertyEnum.propertyInformation]: {
    propertyName: "Agilysys Inc",
    addressLine1: "3655 Brookside Pkwy",
    addressLine2: "Suite 300",
    city: "Alpharetta",
    state: "Georgia",
    country: "United States",
    zipCode: "30004",
    phoneNumber: "5715644057",
    email: "sales@agilysys.com",
    checkinTime: "2025-04-09T19:00:00.000Z",
    checkoutTime: "2025-04-09T16:00:00.000Z",
  },
  [GolfPropertyEnum.outletSetup]: [
    {
      id: 1,
      "Outlet Name": "sample_test_agilysys_outlet1",
      "Terminal ID": "1",
      "Profit Center ID": "1",
      "Auto Prints Receipts": "yes",
    },
  ],
  [GolfPropertyEnum.courses]: [
    {
      id: 1,
      "Course Name": "sample_test_agilysys_palmer",
      "Default Outlet": "Palmer Gift Shop",
      "Duration of Play 9 Holes": 150,
      "Duration of Play 18 Holes": 270,
    },
  ],
  [GolfPropertyEnum.lessonLocation]: [
    {
      id: 1,
      "Lesson Locations": "sample_test_agilysys_palmer",
    },
  ],
  [GolfPropertyEnum.cancelReasons]: [
    {
      id: 1,
      "Cancel Reasons": "sample_test_agilysys_palmer",
    },
  ],
  [GolfPropertyEnum.allocationBlocks]: [
    {
      id: 1,
      "Allocation Block Code": "sample_test_agilysys_open",
      "Allocation Block Name": "Open",
      "Days out": 0,
      Active: true,
      "Color Options": "#000000",
      "Switch To": "Open",
      Time: "2025-04-09T20:28:43.519Z",
      "Show on Tee Sheet": "Yes",
      "Closed ?": "Yes",
    },
  ],
  [GolfPropertyEnum.playerTypes]: [
    {
      id: 1,
      "Player Type": "sample_test_agilysys_Resort Guest",
      "Days out Start": 0,
      "Days out End": 365,
      Guarantee: "sample_test_agilysys_no",
      "Available on Web": "Yes",
      "Allow Single Player in Open Tee Time": "Yes",
      Active: true,
    },
  ],
  [GolfPropertyEnum.rateTypes]: [
    {
      id: 1,
      "Rate Type": "sample_test_agilysys_Day Guest 18",
      "Days Out Start": 0,
      "Days out End": 365,
      Guarantee: "sample_test_agilysys_yes",
      Active: true,
      "Suppress on Receipt": "No",
      "9 Hole": "No",
      "Available on Web": "No",
      "Min # Players": 2,
    },
  ],
  [GolfPropertyEnum.playerAllocationBlock]: [
    {
      id: 1,
      "Allocation Block Code": "sample_test_agilysys_Open",
      "Player Type": "Day Guest",
      "Rate Type": "sample_test_agilysys_Resort Guest Junior",
    },
  ],
  [GolfPropertyEnum.teeTimeIntervalTemplates]: [
    {
      id: 1,
      "Template Code": "sample_test_agilysys_Code",
      "Template Name": "sample_test_agilysys_Name",
    },
  ],
  [GolfPropertyEnum.teeTimeIntervalSetup]: [
    {
      id: 1,
      "Start Date": new Date().toISOString(),
      "End Date": new Date(
        new Date().setFullYear(new Date().getFullYear() + 3),
      ).toISOString(),
      // "Start Time": "7:00 AM",
      // "End Time": "5:00 PM",
      Course: "sample_test_agilysys_Palmer",
      "# of Minutes": 10,
      "Show on Tee Sheet": "sample_test_agilysys_true",
      "Closed ?": true,
      "Available Days of Week": {
        monday: false,
        tuesday: true,
        wednesday: true,
        thursday: false,
        friday: true,
        saturday: true,
        sunday: true,
      },
    },
  ],
  [GolfPropertyEnum.rainCheckSetup]: [
    {
      id: 1,
      Course: "sample_test_agilysys_Palmer",
      "Hole Number": 1,
      "Green Fee %": 100,
      "Cart Fee %": 100,
      "Green Fee $": 10,
      "Cart Fee $": 20,
    },
  ],
  [GolfPropertyEnum.roleSetup]: [
    {
      id: 1,
      "Role Code": "sample_test_agilysys_GOLFMGR",
      "Role Name": "Golf Manager",
      Active: true,
    },
  ],
  [GolfPropertyEnum.categoryGroups]: [
    {
      id: 1,
      "Category Group": "sample_test_agilysys_Golf Green Fees",
      Active: true,
    },
  ],
  [GolfPropertyEnum.retailCategories]: [
    {
      id: 1,
      "Category Group": "sample_test_agilysys_Golf Green Fees",
      "Category Name": "Green Fees",
      "Eligible for Discount": "Yes",
      Active: true,
    },
  ],
  [GolfPropertyEnum.retailSubCategories]: [
    {
      id: 1,
      "Sub Category Number": 1,
      "Sub Category Name": "sample_test_agilysys_Mens",
      Active: true,
    },
    {
      id: 2,
      "Sub Category Number": 2,
      "Sub Category Name": "Shirts",
      Active: true,
    },
    {
      id: 3,
      "Sub Category Number": 3,
      "Sub Category Name": "Small",
      Active: true,
    },
    {
      id: 4,
      "Sub Category Number": 4,
      "Sub Category Name": "Red",
      Active: true,
    },
  ],
  [GolfPropertyEnum.taxes]: [
    {
      id: 1,
      Outlet: "sample_test_agilysys_Agilysys Golf Resort",
      "Tax Name": "Sales Tax",
      "Allow Tax on Service Charge": "sample_test_agilysys_no",
      "Allow Tax on Gratuity": "No",
      "Percentage or Flat Amount": "%",
      Value: 6.0,
      "Start Date": new Date().toISOString(),
      "End Date": new Date(
        new Date().setFullYear(new Date().getFullYear() + 3),
      ).toISOString(),
      "Default to all Retail Items": "Yes",
    },
  ],
  [GolfPropertyEnum.discountTypes]: [
    {
      id: 1,
      "Discount Type": "sample_test_agilysys_Employee",
      Active: true,
    },
  ],
  [GolfPropertyEnum.quickSaleCategories]: [
    {
      id: 1,
      "Quick Sale Category": "sample_test_agilysys_Rentals",
      "Outlet Name": "sample_test_agilysys_Palmer Pro Shop",
      Active: true,
    },
  ],
  [GolfPropertyEnum.vendorTypes]: [
    {
      id: 1,
      "Vendor Type": "sample_test_agilysys_Golf Equipment",
    },
  ],
  [GolfPropertyEnum.vendorSetup]: [
    {
      id: 1,
      "Vendor Code": "sample_test_agilysys_GolfCode",
      "Vendor Name": "sample_test_agilysys_Name",
    },
  ],
  [GolfPropertyEnum.discountReasons]: [
    {
      id: 1,
      "Discount Reason": "sample_test_agilysys_Frequent Guest",
      Active: true,
    },
  ],
  [GolfPropertyEnum.rateSetup]: [
    {
      id: 1,
      Course: "sample_test_agilysys_Palmer",
      "Rate Type": "Day Guest 18",
      "Green Fee Amount($)": 150.0,
      "Green Fee Item #": 1,
      "Cart Fee Amount($)": 25.0,
      "Cart Fee Item #": 6,
      "Start Date": new Date().toISOString(),
      "End Date": new Date(
        new Date().setFullYear(new Date().getFullYear() + 3),
      ).toISOString(),
      "Available Days of the Week": {
        monday: false,
        tuesday: true,
        wednesday: true,
        thursday: false,
        friday: true,
        saturday: true,
        sunday: true,
      },
    },
  ],
  [GolfPropertyEnum.ratePlan]: [
    {
      id: 1,
      Courses: "sample_test_agilysys_Palmer",
      RateType: "Day Guest 18",
      StartDate: "2026-10-07",
      EndDate: "2026-12-31",
      StartTime: "07:00",
      EndTime: "18:00",
      AvailableDaysOfWeek: "Wednesday, Thursday, Friday",
      GreenFee: 150,
      CartFee: 25,
      GreenFeeRetailItem: "10",
      CartFeeRetailItem: "10",
      EntryFee: 0,
      EntryFeeRetailItem: "10",
    },
  ],
};

export const reserveSampleData = {
  [ReservePropertyEnum.propertyInformation]: {
    propertyName: "Agilysys Inc",
    addressLine1: "3655 Brookside Pkwy",
    addressLine2: "Suite 300",
    city: "Alpharetta",
    state: "Georgia",
    country: "United States",
    zipCode: "30004",
    phoneNumber: "5715644057",
    email: "sales@agilysys.com",
    checkinTime: "2025-04-09T19:00:00.000Z",
    checkoutTime: "2025-04-09T16:00:00.000Z",
  },
  [ReservePropertyEnum.outletSetup]: [
    {
      id: 1,
      "Outlet Name": "sample_test_agilysys_Main Shop",
      "Terminal ID": "1",
      "Profit Center ID": "",
      "Auto Print Receipts": "Yes",
      Active: "Yes",
    },
  ],
  [ReservePropertyEnum.miscItems]: [
    {
      id: 1,
      Code: "sample_test_agilysys_default_misc",
      Name: "sample_test_agilysys_Default misc profile",
      "Guest waiver form required": "Yes",
      "Confirmation Email": "Always",
      "Update Email": "Always",
      "Cancel Email": "Always",
      "Allow to book/edit reservations for past date/time": "Yes",
      "Allow to edit Checked-In Reservation": "Yes",
      "No. of past days to view/edit past reservation": "7",
      "Default Communication Preference": "Email",
    },
  ],
  [ReservePropertyEnum.propertyQuestions]: [
    {
      id: 1,
      acceptsWebReservations: true,
      closeSameDayWebReservationAt: "2025-04-23T07:00:00.000Z",
      requiredPartyField: "phone",
      showCheckedInReservationsInTimelineView: true,
      "Accepts Online Reservations": "Yes",
      "Max Party Size": "6",
      "Days In Advance for Reservations": "365",
      "Reservation Cut-Off Minutes": "15",
      "Close Same Day Reservations Time": "No Restrictions",
      "Minimum Time to Cancel Reservation": "12 hours",
      "Automatic or Manual Slotting":
        "Automatic - System will auto assign table (Most Common, tables can still be adjusted)",
      "Reservation to be held after res time": "15",
      "Auto Suggest Tables": "Yes",
      "No show Fee Amount": "",
      "No show Fee Type": "",
      "No show Fee Schedule": "",
      "No show Applies to Party Size": "",
    },
  ],
  [ReservePropertyEnum.userDetails]: [
    {
      id: 1,
      Name: "sample_test_agilysys_Demo user",
      "First Name": "sample_test_agilysys_Demo",
      "Last Name": "User",
      "Country Code": "+1",
      Mobile: "5555550100",
      "Email address": "demo.user@example.com",
      "Employee code": "sample_test_agilysys_EMP001",
      Username: "sample_test_agilysys_demouser",
      PIN: "",
      "Retail role": false,
      Password: "",
      "Role Code": "sample_test_agilysys_RES_MGR",
      "Role Name": "sample_test_agilysys_Reserve Manager",
      "Outlet Access": "sample_test_agilysys_Main Shop",
      Active: true,
    },
  ],
  [ReservePropertyEnum.roles]: [
    {
      id: 1,
      "Role Code": "sample_test_agilysys_RES_MGR",
      "Role Name": "sample_test_agilysys_Reserve Manager",
      Active: true,
    },
    {
      id: 2,
      "Role Code": "sample_test_agilysys_RES_INST",
      "Role Name": "sample_test_agilysys_Instructor Role",
      Active: true,
    },
  ],
  [ReservePropertyEnum.userPermissions]: [
    {
      id: 1,
      "Role Code": "sample_test_agilysys_RES_MGR",
      "Role Name": "sample_test_agilysys_Reserve Manager",
      "Booking Actions": ["Add booking", "edit bookings", "overbook"],
      "Guest Communication": [
        "book in slots with inappropriate size",
        "page parties",
        "view feedback",
      ],
      "Instructor Schedule": [],
      "Manage Activity": ["cancel activity", "modify activity"],
      "Manage Locations": ["move seated parties", "no-show reservations"],
      Reports: [],
      "Settings Access": ["users", "permissions", "roles"],
      "Client Profile": [
        "675 - Copy Client Profile",
        "600 - Add New Client Profile",
      ],
      "Commission Setup": ["800 - Commission Class Setup"],
      "Fiscal Reports": ["2500000", "2500010"],
      Interface: ["12091 - PMS Integration Setup"],
      "Inventory Management": ["8731 - Inventory", "8734 - Receiving"],
      Retail: ["3000 - Create Transaction", "3045 - Settle to Cash"],
      "Retail Reports": ["8005 - Transaction Report", "8010 - Revenue Summary"],
      "Retail Setup": ["7000 - Outlet Setup", "7035 - Retail Categories"],
      "Retail Transactions": ["5005 - Void Transaction"],
      Utilities: ["20040 - Email Templates", "2430 - Day End"],
    },
  ],
  [ReservePropertyEnum.ratePlan]: [
    {
      id: 1,
      "Special Meal": "sample_test_agilysys_Vegan Lunch",
      "Base Price": "50",
      "Guest Type Pricing": "1.Adult - $100",
      "Hourly Price (if Applicable)": "$30 for 1hr",
      "Daily/Weekly": "",
      Code: "sample_test_agilysys_Vegan Lunch",
      Name: "sample_test_agilysys_50 | $30 for 1hr",
    },
  ],
  [ReservePropertyEnum.serviceCharge]: [
    {
      id: 1,
      "Tax Type": "Personal Training",
      Value: "",
      "Calculation Type": "Percentage",
      "Start Date": "2025-04-01T00:00:00.000Z",
      "End Date": null,
      Code: "sample_test_agilysys_Personal Training",
      Name: "sample_test_agilysys_",
    },
  ],
  [ReservePropertyEnum.taxes]: [
    {
      id: 1,
      "Tax Type": "Sales Tax",
      Value: "8%",
      "Calculation Type": "Percentage",
      "Start Date": "2025-01-01T00:00:00.000Z",
      "End Date": "2026-12-31T00:00:00.000Z",
      Code: "sample_test_agilysys_Sales Tax",
      Name: "sample_test_agilysys_8%",
    },
  ],
  [ReservePropertyEnum.location]: [
    {
      id: 1,
      Area: "sample_test_agilysys_Main",
      "Location Type": "sample_test_agilysys_Indoor",
      Active: true,
    },
  ],
  [ReservePropertyEnum.tables]: [
    {
      id: 1,
      "Seating Area": "sample_test_agilysys_Main Dining",
      "Seating Type": "sample_test_agilysys_Booth",
      Active: true,
    },
  ],
  [ReservePropertyEnum.instructors]: [
    {
      id: 1,
      "Sr. No": "1",
      "First Name": "sample_test_agilysys_Jane",
      "Last Name": "Smith",
      "Employee code": "sample_test_agilysys_INST001",
      "Expertise level": "Trainer",
      "Country Code": "+1",
      Mobile: "5555550100",
      "Email address": "jane.smith@example.com",
      "Name - Instructor Level": "sample_test_agilysys_Jane Smith - Trainer",
      Code: "sample_test_agilysys_INST001",
      Name: "sample_test_agilysys_Jane Smith - Trainer",
    },
  ],
  [ReservePropertyEnum.reservationGuestNotes]: [
    {
      id: 1,
      Category: "sample_test_agilysys_General",
      Subcategory: "sample_test_agilysys_Arrival",
      "Reservation notes":
        "sample_test_agilysys_Internal reservation note text",
      "Guest notes": "sample_test_agilysys_Guest-facing note text",
    },
  ],
  [ReservePropertyEnum.operationHours]: [
    {
      id: 1,
      Day: "Monday",
      "Open Start": "2025-04-23T06:00:00.000Z",
      "Open End": "2025-04-23T21:00:00.000Z",
      "Staff Shifts":
        '[{"start":"2025-04-23T06:00:00.000Z","end":"2025-04-23T12:00:00.000Z","label":""},{"start":"2025-04-23T14:00:00.000Z","end":"2025-04-23T17:00:00.000Z","label":""},{"start":null,"end":null,"label":"Late Night"}]',
      Code: "sample_test_agilysys_Monday",
      Name: "sample_test_agilysys_6:00 AM - 9:00 PM | shifts",
    },
  ],
  [ReservePropertyEnum.activities]: [
    {
      id: 1,
      "Activity Code": "AA123",
      "Activity Name": "Beach Boot camp",
      "Activity Type": "Group lesson",
      "Class Type": "By session",
      "Activity Description": `Come for a workout that is never the same to keep your body guessing! Designed to build strength, endurance, burn calories, and build lean muscle. This boot camp style workout in the sand will not disappoint. Rain or shine, hot or cold, we'll see you on the beach! All equipment provided. Towel, sunscreen and drinking water recommended.`,
      "Activity Category": "Fitness",
      "Activity Sub-Category": "Fitness",
      "Min Group Size": "1",
      "Max Group Size": "5",
      "Min Activity Strength": "N/A",
      "Max Activity Strength": "N/A",
      "Allow Overbook Reservation": "",
      "Allow Standby Reservation": "No",
      "Auto confirmation of standby after cancellation": "",
      "Max Standby Strength": "",
      "Guest Type": "",
      "Guest Type Pricing": "",
      "Membership Type": "",
      "Membership Pricing": "",
      "Start Date": "",
      "End Date": "",
      "Days of the week": "M, T, W, TH, F",
      "Start Time": "1970-01-01T18:00:00.000Z",
      "End Time": "1970-01-01T19:00:00.000Z",
      "Number of Locations": "1",
      "Location Name": "Sanctuary Front Beach",
      "Staff/Guide": "Mike",
      "Require prepayment": "Yes",
      "Payment Type": "Charge on Booking",
      "Base Price": "25 per person",
      "Cancellation Fee Required":
        "Applies — see policy (24 hours prior, full charge same day)",
      "Cancellation Fee Type": "Percentage",
      "Cancellation deadline": "24 hours prior to the time of the reservation.",
      "Cancellation Policy Description": `Cancellation or modification deadline is 24 hours prior to the time of the reservation, any reservations cancelled the same day will be charged in full.`,
      "Allow Additional Guest Details": "",
      "Collect Additional Employee Details": "",
      "Activity Image (1920 - 1080px)": "",
      "Reservation Parameter (Age/Height Restriction if any)":
        "Age(Min-7,Max-14) Height, Weight",
      "Addons Name ( Mandatory/Optional for an activity)":
        "Eg: Any Fitness equipment",
      "Available for web Reservation": "No",
      "Check-In Cut off minutes": "",
      Code: "sample_test_agilysys_AA123",
      Name: "sample_test_agilysys_Beach Boot camp",
    },
  ],
  [ReservePropertyEnum.equipmentsAddOns]: [
    {
      id: 1,
      "Add-On Name": "Dry Bags",
      "Add-On Type": "Per Reservation",
      "Add-On Description": "",
      "Add-On Category": "Paddle Board Accessories",
      "Add-On Sub-Category": "Paddle Board Accessories",
      "Qty in Stock": "100",
      "Pricing Type": "By duration",
      Price: "$10",
      "Additional Rates per mins": "",
      Code: "sample_test_agilysys_Dry Bags",
      Name: "sample_test_agilysys_Per Reservation",
    },
  ],
};
